import React, { Component } from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';
import { useScheduledReportStore } from '../../lib/stores/scheduledReport'
import localforage from "localforage";

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
  actions: PropTypes.element
};

function hasClass( target, className ) {
  return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
}

class SelectableListItem extends Component {

  constructor (props) {
    super(props);
    this.hasActions = false;
    this.checkbox = React.createRef();
    this.state = {
      scheduled: false  
    };

    if(this.props.actions){
        this.hasActions = this.props.actions.props.children.filter(o => o).length;
    }
  }

  componentDidMount(){
    if(this.props.selected){
      window.$('#' + this.props.id).prop('checked', true);
    }

    this.isScheduled()
      .then(scheduled => this.setState({ scheduled }));
  }

  handleClick(e){
    if(this.checkbox.current && this.checkbox.current.checked){
      if(hasClass(e.target, 'fa-ellipsis-h')){
        return;
      }
      this.props.onSelect();
    }
  }

  async isScheduled() {
    const scheduledReports = useScheduledReportStore.getState().scheduledReports;
    switch(this.props.name) {
      case 'companies': {
        const scheduledCompanyIds = [...new Set(scheduledReports.map(report => report.data.relation_ids.company_id))];
        const companyScheduled = scheduledCompanyIds.includes(Number(this.props.id));

        return companyScheduled;
      }
      case 'locations': {
        const scheduledLocationIds = [...new Set(scheduledReports.map(report => report.data.relation_ids.location_id))];
        const scheduledSublocationIds = [...new Set(scheduledReports.map(report => report.data.relation_ids.sublocation_id))];
        
        const locationScheduled = scheduledLocationIds.includes(Number(this.props.id));
        const sublocationScheduled = scheduledSublocationIds.includes(Number(this.props.id));

        return locationScheduled || sublocationScheduled;
      }
      case 'removals': {
        const removalTypes = await localforage.getItem('bs_removals');
        return removalTypes && removalTypes.find(removal => removal.id === Number(this.props.id));  
      }
      default: return false;
    }
  }

  isOffline() {
    return window.navigator.onLine === false;
  }

  isDisabled() {
    const scheduled = this.state.scheduled;
    const offline = this.isOffline();

    return offline && !scheduled && ['sublocations', 'removals'].includes(this.props.name);
  }

  render () {
    return (
      <div>
        
        {/* Hidden input for actual activation callback */}
        <input 
          type="radio" 
          ref={this.checkbox}
          value={ this.props.id }
          name={ this.props.name } 
          id={ this.props.id }
          className="d-none"
          {...this.props.onSelect && { onChange: (e) => this.props.onSelect(e) }} 
        />

        {/* Label that displays the data */}
        <label
          onClick={(e) => this.handleClick(e)}
          htmlFor={ this.props.id }
          className={`md-location-box md-checkbox-area ${this.isDisabled() ? 'disabled' : ''}`}
        >
          <div className="align-items-center d-flex flex-row" style={{minHeight: '51px'}}>
              
              {/* Render the left-side image */}
              {(this.props.image || '').includes('icon_pakkingen') ? (
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                  width="74.000000" height="32.000000pt" viewBox="0 0 104.000000 64"
                  preserveAspectRatio="xMidYMid meet" className='d-inline-block mr-4'
                >
                  <g transform="translate(0.000000,62.000000) scale(0.100000,-0.100000)"
                  fill="#000000" stroke="none">
                  <path d="M313 601 c-3 -14 -15 -21 -37 -23 -27 -3 -31 -7 -34 -35 l-3 -33
                  -114 0 c-73 0 -116 -4 -121 -11 -13 -21 21 -29 127 -29 98 0 107 -2 112 -20 4
                  -15 14 -20 36 -20 26 0 31 -4 31 -24 0 -21 -6 -25 -32 -28 l-33 -3 0 -65 0
                  -65 33 -3 c26 -3 32 -7 32 -28 0 -20 -5 -24 -31 -24 -22 0 -32 -5 -36 -20 -5
                  -18 -14 -20 -112 -20 -106 0 -140 -8 -127 -29 5 -7 48 -11 121 -11 l114 0 3
                  -32 c3 -29 7 -33 34 -36 22 -2 34 -9 37 -23 5 -18 13 -20 94 -17 88 3 88 3 91
                  31 5 38 39 38 44 0 3 -28 3 -28 91 -31 81 -3 89 -1 94 17 3 14 15 21 37 23 27
                  3 31 7 34 36 l3 32 114 0 c73 0 116 4 121 11 13 21 -21 29 -127 29 -98 0 -107
                  2 -112 20 -4 15 -14 20 -36 20 -26 0 -31 4 -31 24 0 21 6 25 33 28 l32 3 0 65
                  0 65 -32 3 c-27 3 -33 7 -33 28 0 20 5 24 31 24 22 0 32 5 36 20 5 18 14 20
                  112 20 106 0 140 8 127 29 -5 7 -48 11 -121 11 l-114 0 -3 33 c-3 28 -7 32
                  -34 35 -22 2 -34 9 -37 23 -5 18 -13 20 -94 17 -88 -3 -88 -3 -91 -30 -2 -20
                  -9 -28 -22 -28 -13 0 -20 8 -22 28 -3 27 -3 27 -91 30 -81 3 -89 1 -94 -17z
                  m152 -291 l0 -275 -57 -3 -58 -3 0 281 0 281 58 -3 57 -3 0 -275z m225 0 l0
                  -281 -57 3 -58 3 -3 265 c-1 146 0 270 3 277 3 8 24 13 60 13 l55 0 0 -280z
                  m-380 195 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10 0 15
                  -11 15 -35z m450 0 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15
                  35 10 0 15 -11 15 -35z m-220 -195 c0 -213 -1 -220 -20 -220 -19 0 -20 7 -20
                  220 0 213 1 220 20 220 19 0 20 -7 20 -220z m-230 0 c0 -29 -4 -40 -15 -40
                  -11 0 -15 11 -15 40 0 29 4 40 15 40 11 0 15 -11 15 -40z m450 0 c0 -29 -4
                  -40 -15 -40 -11 0 -15 11 -15 40 0 29 4 40 15 40 11 0 15 -11 15 -40z m-450
                  -195 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10 0 15 -11
                  15 -35z m450 0 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10
                  0 15 -11 15 -35z"/>
                  </g>
                </svg>
              ) : this.props.image && (
                <img 
                  src={this.props.image} 
                  alt={this.props.title} 
                  className="d-inline-block mr-4 tw-max-w-16"
                /> 
              )}

              {/* Render the title and subtitle */}
              <div>
                <strong>{this.props.title}</strong>
                {this.props.subtitle && (
                  <p className="text-muted">{this.props.subtitle}</p>
                )}
              </div>
              
              {/* Render right-side icons */}
              <div className="ml-auto">
                
                {/* Offline icon if state = scheduled */}
                {this.state.scheduled && (
                  <i className="fas fa-wifi-slash mr-2 textgreen" />
                )}

                {/* Options icon */}
                {this.hasActions && (
                  <i 
                    onClick={(e) => {
                      e.preventDefault();
                      e.nativeEvent.stopImmediatePropagation();
                      window.$('#listActions' + this.props.id).modal('show');
                    }}
                    className="far fa-ellipsis-h text-muted"
                    data-toggle="modal" 
                    data-target={'#listActions' + this.props.id}
                  />
                )}

              </div>
              
          </div>
        </label>
        
        {/* Render the actions modal if actions are included*/}
        {this.hasActions && (
          <div 
            className="modal bottom modal-menu" 
            id={'listActions' + this.props.id} 
            tabIndex="-1"
            role="dialog"
            aria-labelledby="listActions"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content align-items-center justify-content-center">
                <div className="container">
                  <div className="row mb-5">
                    <div className="col-md-6 col-12 offset-md-3 d-flex flex-column line-height-40">
                      {this.props.actions}
                    </div>
                  </div>
                </div>
                <a data-dismiss="modal" className="textred text-uppercase font-size-18 cur-p">
                  {__('app.general.close_menu')}
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

}

SelectableListItem.propTypes = propTypes;

export default SelectableListItem;
